interface Props {
  monthlyTotal: number;
  yearlyTotal: number;
}

function fmt(n: number) {
  return n.toLocaleString("th-TH", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export default function ExpenseTotalsCard({
  monthlyTotal,
  yearlyTotal,
}: Props) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:gap-4">
      <div className="rounded-[14px] px-4 py-4 sm:px-6 sm:py-5 bg-card border-[0.5px] border-border shadow-card">
        <p className="text-[12px] text-muted-foreground mb-1">Monthly total</p>
        <p className="text-[20px] sm:text-[26px] font-bold text-foreground [font-variant-numeric:tabular-nums]">
          ฿{fmt(monthlyTotal)}
        </p>
      </div>
      <div className="rounded-[14px] px-4 py-4 sm:px-6 sm:py-5 bg-card border-[0.5px] border-border shadow-card">
        <p className="text-[12px] text-muted-foreground mb-1">Yearly total</p>
        <p className="text-[20px] sm:text-[26px] font-bold text-foreground [font-variant-numeric:tabular-nums]">
          ฿{fmt(yearlyTotal)}
        </p>
      </div>
    </div>
  );
}
